import { FC } from 'react'
import { LayoutHeader } from '@/components/domains/layouts'
import PolicyBeforePrivacy from '@/components/domains/policy/PolicyLocationBeforeService20260805'

const PagePolicyBeforeLocationPrivacy20260805: FC = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyBeforePrivacy />
    </>
  )
}

export default PagePolicyBeforeLocationPrivacy20260805
